const Modal = ({text, helpers}: any) => {
  const { setModal } = helpers
  const close = () => setModal(2)

  return (<>
    <div className="modalbg" onClick={close}>
      <div className="modal">
        <h2 className="text">{text}</h2>
        <div className="modalbtn" onClick={close}>
          Zapri
        </div>
      </div>
    </div>
    <style jsx>{`
      .modalbg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .modal {
        background-color: white;
        padding: 2rem;
        width: 80%;
        max-width: 500px;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        
        .text {
          margin: 0 auto;
          text-align: center;
          margin-bottom: 4rem;
        }
      }
      .modalbtn {
        padding: 1rem;
        max-width: 200px;
        margin: 0 auto;
        border-radius: 0.5rem;
        background-color: black;
        color: white;
        text-align: center;
        cursor: pointer;
      }
    `}</style>
  </>);
}

export default Modal;